module.exports = __webpack_public_path__ + "img/club_house_mini.c4902b40.jpg";